var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('dashboard-layout',[_c('case-menu',{attrs:{"slot":"left","case-summary":_vm.caseModel},on:{"reload":_vm.reloadCaseSummary,"updatedCase":_vm.updatedCase},slot:"left"}),(_vm.isNonEmptyCase)?_c('router-view',{attrs:{"slot":"right"},slot:"right"}):_c('case-empty-state',{attrs:{"slot":"right"},slot:"right"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }